import { AppState } from "store/rootReducer";
import { createSelector } from "reselect";

const annotationsState = (state: AppState) => state.annotations;

export const getSelectedAnnotation = createSelector(annotationsState, ({ selectedAnnotation }) => selectedAnnotation);

export const getAnnotations = createSelector(annotationsState, ({ annotations }) => annotations);

export const getAnnotationsPermissions = createSelector(annotationsState, ({ permissions }) => permissions);

export const getAnnotationsStatus = createSelector(annotationsState, ({ isProcessing }) => ({ isProcessing }));

export const getShowAdditionalActions = createSelector(annotationsState, ({ newlyAddedAnnotations, annotations }) => {
    return newlyAddedAnnotations > 0 || annotations.filter((annotation) => annotation.modified).length > 0;
});

export const getDirtyStatus = createSelector(annotationsState, ({ isDirty }) => isDirty);
